export const formatNumber = (num: number): string => {
	if (num >= 1000000000) {
		return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'b';
	} else if (num >= 1000000) {
		return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'm';
	} else if (num >= 1000) {
		return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
	} else {
		return num.toFixed(2).toString();
	}
};

export function toDecimal(value: string, decimal: number): number {
	const num = parseInt(value || '0');
	if (isNaN(num)) {
		throw new Error('Invalid number format');
	}
	return num / Math.pow(10, decimal || 6);
}
